import reducer from './reducers';

export { default as uploadSelectors } from './selectors';
export { default as uploadOperations } from './operations';
export { default as uploadTypes } from './types';
export { default as uploadActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/upload/index.js